import RxGateChosenReceiptBlock from './RxGateChosenReceiptBlock';

export default RxGateChosenReceiptBlock;
